import { render, staticRenderFns } from "./IndexEdit.vue?vue&type=template&id=3963d12c&scoped=true"
import script from "./IndexEdit.vue?vue&type=script&lang=js"
export * from "./IndexEdit.vue?vue&type=script&lang=js"
import style0 from "./IndexEdit.vue?vue&type=style&index=0&id=3963d12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963d12c",
  null
  
)

export default component.exports